// export class FormFieldBase<T> {
//     value: T | undefined;
//     key: string;
//     label: string;
//     required: boolean;
//     checked: boolean;
//     order: number;
//     controlType?: string;
//     inputType?: string;
//     placeholder: string;
//     validator: string;
//     pattern?: string;
//     invalidFormatMsg: string;
//     maxLength?: number;
//     mask?: string;
//     styles?: {[key: string]: string};
//     options: {key: string, value: string}[];
  
//     constructor(options: {
//         value?: T;
//         key?: string;
//         label?: string;
//         required?: boolean;
//         checked?: boolean;
//         order?: number;
//         controlType?: string;
//         inputType?: string;
//         placeholder?: string;
//         validator?: string;
//         pattern?: string;
//         invalidFormatMsg?: string;
//         maxLength?: number;
//         mask?: string;
//         styles?: {[key: string]: string};
//         options?: {key: string, value: string}[];
//       } = {}) {
//       this.value = options.value;
//       this.key = options.key || '';
//       this.label = options.label || '';
//       this.required = !!options.required;
//       this.checked = !!options.checked;
//       this.order = options.order === undefined ? 1 : options.order;
//       this.controlType = options.controlType;
//       this.inputType = options.inputType;
//       this.placeholder = options.placeholder!;      
//       this.validator = options.validator || '';
//       this.pattern = options.pattern;
//       this.invalidFormatMsg = options.invalidFormatMsg!;
//       this.maxLength = options.maxLength;
//       this.mask = options.mask;
//       this.styles = options.styles!;
//       this.options = options.options || [];
//     }
//   }

  

export class FormFieldBase<T> {
  value: T | undefined;
  key: string;
  label: string;
  required: boolean;
  checked: boolean;
  order: number;
  controlType?: string;
  inputType?: string;

  placeholder?: string;
  validator: string;
  pattern?: string;
  invalidFormatMsg?: string;
  maxLength?: number;
  mask?: string;

  styles: { [key: string]: string }; // now always an object
  options: { key: string; value: string }[];

  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    required?: boolean;
    checked?: boolean;
    order?: number;
    controlType?: string;
    inputType?: string;
    placeholder?: string;
    validator?: string;
    pattern?: string;
    invalidFormatMsg?: string;
    maxLength?: number;
    mask?: string;
    styles?: { [key: string]: string };
    options?: { key: string; value: string }[];
  } = {}) {
    this.value = options.value;
    this.key = options.key ?? '';
    this.label = options.label ?? '';
    this.required = !!options.required;
    this.checked = !!options.checked;
    this.order = options.order ?? 1;
    this.controlType = options.controlType || 'text';
    this.inputType = options.inputType ?? 'text';

    // Provide sensible defaults
    this.placeholder = options.placeholder ?? '';
    this.validator = options.validator ?? '';
    this.pattern = options.pattern ?? '';
    this.invalidFormatMsg = options.invalidFormatMsg ?? '';
    this.maxLength = options.maxLength ?? 0;
    this.mask = options.mask ?? '';

    this.styles = options.styles ?? {};
    this.options = options.options ?? [];
  }
}

